"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeListToArray = (nodeList) => {
    return [].slice.call(nodeList);
};
//# sourceMappingURL=nodeListToArray.js.map